import ApiProvider from "../../../lib/providers/ApiProvider";
import { serviceUtil } from "../../commons/utils/services";
import { HeadersMapping } from "../../commons/mappings/headers.mapping";
import { URLConfiguration } from "../../commons/constants/url.configuration";
import CotizacionRequest from "../../commons/mappings/cotizacionRequest.mapping";

class CotizarInformacionProvider {
    
    constructor() {
        this.paths              = URLConfiguration.paths;
        this.cotizacionRequest  = new CotizacionRequest();
        this.apiProvider        = new ApiProvider(process.env.REACT_APP_BASE_SERVICE_PATH)
    }

    postCotizarSimulacion = async (datosConsulta) => {
        const headers   = HeadersMapping.getHeaderService();
        const request   = this.cotizacionRequest.postCotizarSimulacion(datosConsulta);
        const pathNew   = serviceUtil.replaceParamUrl(this.paths.simulacionProductosRentas.cotizacion, { idSimulacion: datosConsulta.idSimulacion });
        let response    = null;
        try {
            response = await this.apiProvider.post( pathNew, request, { headers } );
        } catch (error) {
            console.log(error);
        }
        return response;
    }

}

export default CotizarInformacionProvider;